export enum DidNotPerformReasonEnum {
  PatientRefused = 1,
  NotNeeded = 2,
  Other = 99
}

export const DidNotPerformReasonOptions = [
{ id: 1, label: 'Patient Refused' },
{ id: 2, label: 'Not Needed' },
{ id: 99, label: 'Other' }
];
